function RepublicOfTheCongo({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1964)">
  <path d="M8.67315 30.228L20.4272 20.4275L30.2277 8.67346C28.7039 5.72046 26.2878 3.30303 23.336 1.77734L11.5726 11.573L1.7771 23.3362C3.30266 26.2882 5.72009 28.7042 8.67315 30.228Z" fill="#FFDA44"/>
  <path d="M27.3142 27.3146C32.3621 22.2667 33.3311 14.6857 30.2233 8.66406L8.66357 30.2238C14.6852 33.3315 22.2663 32.3624 27.3142 27.3146Z" fill="#D80027"/>
  <path d="M4.68582 4.68581C-0.362049 9.73368 -1.33105 17.3148 1.77664 23.3364L23.3364 1.77669C17.3148 -1.33111 9.73369 -0.361991 4.68582 4.68581Z" fill="#6DA544"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default RepublicOfTheCongo;
